<template>
  <b-row>
    <b-col sm="12" class="mb-3">
      <h5 class="package-name-background p-2"><strong>{{ tour.name }} / {{ date.date }}</strong></h5>
      <b-row>
        <b-col sm="4">
          <h6 class="package-title font-weight-bold border-bottom pb-1 text-primary">Detalii pret</h6>
          <b-table-simple responsive small bordered>
            <b-tbody>
              <b-tr>
                <b-th class="package-name-background">Total client</b-th>
                <b-td>{{ date.price.gross + date.price.tax }} {{ tour.currency }}</b-td>
              </b-tr>
              <b-tr>
                <b-th class="package-name-background">Taxe</b-th>
                <b-td>{{ date.price.tax }} {{ tour.currency }}</b-td>
              </b-tr>
              <b-tr>
                <b-th class="package-name-background"> Comision</b-th>
                <b-td>{{ date.price.commission }} {{ tour.currency }}</b-td>
              </b-tr>
              <b-tr>
                <b-th class="package-name-background">Total plata</b-th>
                <b-td>{{ date.price.gross + date.price.tax - date.price.commission }} {{ tour.currency }}</b-td>
              </b-tr>
            </b-tbody>
          </b-table-simple>
        </b-col>
        <b-col sm="4">
          <h6 class="package-title pb-1 font-weight-bold border-bottom text-primary">Discounturi aplicate</h6>
          <div v-for="(discount, discountIndex) in date.discounts"  :key="'discount' + discountIndex">
            <h6 class="package-title">{{ discount.label }}</h6>
            <p class="mb-1" v-if="discount.description">{{ discount.description }}</p>
            <p class="mb-1">
              <b>Valabilitatea ofertei: </b>&nbsp;
              <span v-if="!discount.bookingFrom && !discount.bookingTo">oricare</span><br/>
              <span v-if="discount.bookingFrom && !discount.bookingTo" class="d-block mb-1">de la {{ formatDate(discount.bookingFrom) }}</span>
              <span v-if="!discount.bookingFrom && discount.bookingTo" class="d-block mb-1">pana la{{ formatDate(discount.bookingTo) }}</span>
              <span v-if="discount.bookingFrom && discount.bookingTo">intre {{ formatDate(discount.bookingFrom) }}
                si {{ formatDate(discount.bookingTo) }}</span>
            </p>
            <p class="mb-1">
            <b>Date calatorie:</b>
              <span v-if="discount.all_dates">&nbsp;oricare data de plecare</span>
              <span v-else>&nbsp;
                <span v-for="(discountDate, dIndex) in discount.dates" :key="`d-${dIndex}`">
                  {{ formatDate(discountDate) }}
                </span>
              </span>
            </p>
            <p class="m-0" v-if="!date.discounts.length">Fara discounturi aplicate</p>
          </div>
        </b-col>
        <b-col sm="4">
          <b-card class="bg-light" no-body v-if="paymentSchedule">
            <b-card-header class="d-flex justify-content-between">
              <b>Programul de plati </b> <b class="text-primary">{{ tour.currency }}</b>
            </b-card-header>
            <b-list-group flush>
              <b-list-group-item v-for="(dd, ddIndex) in paymentSchedule" :key="'dd' + ddIndex">
                {{ formatDate(dd.date) }} - <b>{{ ceil(dd.amount) || 'scadenta' }} </b>
              </b-list-group-item>
            </b-list-group>
          </b-card>
        </b-col>
        <b-col sm="12">
          <b-card class="bg-light">
            <h6 class="package-title font-weight-bold border-bottom pb-1 text-primary">Penalizari in caz de anulare a rezervarii:</h6>
            <small>
              <p>Anularea rezervarilor efectuate se va face conform termenelor de anulare mentionate in anexa contractului de comercializare a pachetelor de servicii turistice pe care il regasiti in B2B la documente utile.<br/>
              Penalizarile se aplica conform termenelor scadente mentionate in rezervare.
              </p>
            </small>
          </b-card>
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>

<script>
import moment from 'moment'
import { paymentSchedule } from 'b2b-common/services/api/tour'

export default {
  name: 'PriceDetails',
  props: {
    tour: {
      type: Object,
      required: true
    },
    date: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      paymentSchedule: null
    }
  },
  async mounted () {
    this.paymentSchedule = await paymentSchedule({ tour: this.tour.id, date: this.date.date })
  },
  methods: {
    formatDate (d) {
      return moment(d, 'YYYY-MM-DD').format('DD/MM/YYYY')
    },
    ceil (no) {
      return Math.ceil(no)
    }
  }
}
</script>
